import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const commentaryLines = [
  "The umpire tosses the coin high in the air...",
  "It's coming down...",
  "And the result is...",
];
const results = ["Bat", "Ball"];

export const CommentaryRevealPage: React.FC = () => {
  const [step, setStep] = React.useState(0);
  const [result, setResult] = React.useState<string | null>(null);
  const [revealing, setRevealing] = React.useState(false);
  const navigate = useNavigate();

  const reveal = () => {
    setRevealing(true);
    setStep(0);
    setResult(null);
    let i = 0;
    const interval = setInterval(() => {
      setStep(i);
      i++;
      if (i === commentaryLines.length) {
        clearInterval(interval);
        const res = results[Math.floor(Math.random() * results.length)];
        setTimeout(() => {
          setResult(res);
          setRevealing(false);
        }, 1200);
      }
    }, 1200);
  };

  return (
    <VStack minH="100vh" justify="center" align="center" bgGradient="linear(to-b, #e0eafc, #cfdef3)">
      <Box position="absolute" top={4} left={4}>
        <Button onClick={() => navigate(-1)} variant="ghost" colorScheme="teal">Back</Button>
      </Box>
      <Heading size="2xl" color="#01579b" mb={2}>Commentary Reveal</Heading>
      <Text fontSize="lg" color="#333" mb={6} textAlign="center">
        Reveal the toss result with dramatic cricket-style commentary!
      </Text>
      <Box w={80} h={24} bg="#fff" borderRadius="xl" boxShadow="md" display="flex" alignItems="center" justifyContent="center" mb={6}>
        <Text fontSize="xl" color="gray.700" textAlign="center">
          {result ? `Result: ${result}` : commentaryLines[step]}
        </Text>
      </Box>
      <Button colorScheme="purple" size="lg" onClick={reveal} loading={revealing}>
        Reveal Result
      </Button>
    </VStack>
  );
};

export default CommentaryRevealPage;
